import * as React from 'react';
import { useForm } from 'react-hook-form';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { MdDownload, MdFileDownload, MdLockOutline, MdOutlineFileDownload, MdVisibility, MdVisibilityOff } from "react-icons/md";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import { CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, Modal, OutlinedInput } from '@mui/material';
import RtlProvider from '../Components/RtlProvider';
import { ContextNotification, severitys } from '../App';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import logo from "../assets/logo-login.png"
import UserApi from '../api/UserApi';
import themes from '../themes';
import CustomLink from '../Components/CustomLink';
import CustomDownloadLink from '../Components/CustomDownloadLink';

import { VscEye, VscEyeClosed } from "react-icons/vsc";

import helper from '../helper';
import RoleSelecting from './RoleSelecting';
import enumMapper from '../enumMapper';



const Login = () => {

    const { open, setOpen } = React.useContext(ContextNotification);
    const { register, formState, handleSubmit, watch } = useForm();
    const [loading, setLoading] = React.useState(false);

    const [openRolesModal, SetOpenRolesModal] = React.useState(false);
    const [roleInfo, setRoleInfo] = React.useState(null);

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };


    const navigate = useNavigate();
    React.useEffect(() => {
        loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
        handleloggedIn();
    }, []);

    const handleloggedIn = () => {
        var Token = localStorage.getItem("token") ?? null;
        if (Token) navigate("/dashboard");

    }

    const onSubmit = (Data) => {
        if ((Data.username.trim() === '') || (Data.password.trim() === '')) {
            setOpen({ IsEnable: true, Message: 'لطفا نام کاربری و رمز عبور را وارد نمائید', severity: severitys.error });
        }
        else if (Data.captchaValue.trim() === '') {
            setOpen({ IsEnable: true, Message: 'لطفا متن تصویر را وارد نمائید', severity: severitys.error });
        }
        else if (SubmitCaptcha(Data.captchaValue))
            submitUser(Data.username, Data.password);
        // userApi.Signin( Data.username,Data.password)
    };
    function SubmitCaptcha(captchavalue) {
        if (validateCaptcha(captchavalue) === true) {
            return true;
        }
        else {
            setOpen({ IsEnable: true, Message: 'متن تصویر نادرست است', severity: severitys.error });
            loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
            return false
        }
    };
    const submitUser = (username, password) => {
        setLoading(true);
        return (
            UserApi.Login(username, password, enumMapper.AppId.Plan)
                .then((res) => {
                    localStorage.setItem("token", res.data.access_token);
                    window.location.pathname = "/Dashboard/Home";
                })
                .catch(err => {
                    setLoading(false);
                    if ((err.response) && (err.response.status == 422)) {
                        const arr = helper.DictionayToList(err.response.data);
                        const roles = arr.map((o) => {
                            return {
                                id: o.key,
                                title: o.value
                            };
                        });
                        handleOpenRoleModal({ username: watch('username'), password: watch('password'), roleIDS: roles });
                    }
                    else {
                        setOpen({ IsEnable: true, Message: 'نام کاربری یا رمز عبور نادرست است', severity: severitys.error });
                        loadCaptchaEnginge(4, '#E9ECE0', '#A800B8', 'numbers');
                    }
                }).finally(() => { })
        );
    }

    const DownloadFile = () => {
        const pdfUrl = "files/avamel-help.pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "راهنما.pdf"; // specify the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleOpenRoleModal = (e) => {
        setRoleInfo(e);
        SetOpenRolesModal(true);
    };
    const handleCloseRoleModal = () => {
        SetOpenRolesModal(false);
        setRoleInfo(null);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 6,
        pt: 2,
        px: 4,
        pb: 3,
        height: '50%',


    };

    return (

        <ThemeProvider theme={themes.defaultTheme}>
            <Container component="main" maxWidth="xs">
                <RtlProvider>
                    <CssBaseline />
                    <Box className="loginlogo" sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <img id="loginlogoimage" src={logo} alt="موسسه عمره سعادت" />
                    </Box>
                    <Box
                        className="login-box boxBack"
                    >
                        <Typography component="h1" variant="h5" sx={{ display: "flex", alignItems: "center", fontSize: '22px', fontFamily: 'BFarnaz !important' }}>
                            <Avatar sx={{ m: 1, bgcolor: 'secondary.main', color: 'secondary' }}><MdLockOutline size={24} /></Avatar>سامانه پلان اقامتی عمره

                        </Typography>
                        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                label="نام کاربری"
                                {...register("username")}
                                autoFocus
                            />
                            {/* <TextField
                                margin="normal"
                                required
                                fullWidth
                                label="رمز عبور"
                                type="password"
                                {...register("password")}
                                autoComplete="current-password"
                            /> */}
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                label="رمز عبور"
                                type={showPassword ? 'text' : 'password'}
                                {...register("password")}
                                autoComplete="current-password"

                                InputProps={{
                                    endAdornment: <InputAdornment position="start"><IconButton
                                        aria-label={
                                            showPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        onMouseUp={handleMouseUpPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VscEye /> : <VscEyeClosed />}
                                    </IconButton></InputAdornment>,
                                }}
                            />
                            <div>
                                <div style={{ fontSize: '12px', textAlign: 'center' }}> <LoadCanvasTemplate reloadText="بارگذاری مجدد" reloadColor="blue" /></div>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="متن تصویر فوق را وارد کنید"
                                    {...register("captchaValue")}
                                    autoFocus
                                />
                            </div>
                            <Button
                                disabled={loading}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color='primary'
                                sx={{ mt: 3, mb: 2 }}
                            >
                                <Typography sx={{ display: "flex", alignItems: "center" }}>
                                    ورود به سامانه
                                    {loading && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                                </Typography>
                            </Button>
                            <CustomDownloadLink
                                title={"راهنمای کارگزار"}
                                href={"files/userGuid.pdf"}
                                icon={<MdOutlineFileDownload size={20} />}
                                download={"راهنمای کارگزار.pdf"} />


                        </Box>
                    </Box>
                </RtlProvider>
                <Modal
                    alignItems='center'
                    open={openRolesModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={modalStyle}>
                        <Typography id="modal-modal-description" >

                            <RoleSelecting roleInfo={roleInfo} />
                            <Button sx={{ marginTop: 3, marginRight: 30 }} onClick={handleCloseRoleModal}>بستن</Button>
                        </Typography>
                    </Box>
                </Modal>
            </Container>
        </ThemeProvider>

    );
}
export default Login;